import { ADD_STYLE, DELETE_STYLE, GET_SIZE, UPDATE_STATE, GET_ONE_SIZE} from "../types";
  
  const initialState = { list: [], single: null,
    pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    },
   };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_SIZE:
        return { ...state, list: payload.data , pagination: payload.pagination };
  
      case UPDATE_STATE:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_STYLE:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_STYLE:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };
      
      case GET_ONE_SIZE:
        return { ...state, single: payload };
      
      default:
        return state;
    }
  };
  
  export default reducer;
  